(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["deco-frame-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('deco-frame-controls')) {
    customElements.define('deco-frame-controls', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        if (!this.root || !this.nativeInputs().length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.scene = '';
        this.root.dataset.decoFrameReady = 'true';
        this.hidden = false;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          const value = button.dataset.decoChoice;
          const input = this.nativeInputs().find((candidate) => candidate.value === value);
          if (!input) return;
          this.rememberScene();
          if (input.checked) {
            this.sync(true);
          } else {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, options);
        this.root.addEventListener('change', (event) => {
          if (!event.target.closest('variant-selects')) return;
          this.rememberScene();
          this.sync(true);
        }, options);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event?.data?.sectionId !== this.root.dataset.section) return;
            this.sync(true);
          });
        }
        this.sync(false);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.unsubscribe?.();
      }

      nativeInputs() {
        return Array.from(this.root.querySelectorAll('[data-deco-native-frame] input[type="radio"]'));
      }

      sceneOf(slide) {
        const alt = slide?.querySelector('img')?.alt.toLowerCase() || '';
        return ['wall hung', 'leaning on wall', 'close up', 'size comparison'].find((scene) => alt.includes(scene)) || '';
      }

      rememberScene() {
        this.scene = this.sceneOf(this.root.querySelector('media-gallery .product__media-item.is-active'));
      }

      sync(selectImage) {
        const inputs = this.nativeInputs();
        const selected = inputs.find((input) => input.checked)?.value || 'Unframed';
        this.querySelectorAll('[data-deco-choice]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.decoChoice === selected));
          button.disabled = !inputs.some((input) => input.value === button.dataset.decoChoice && !input.disabled);
        });
        this.filterGallery(selected.toLowerCase(), selectImage);
      }

      filterGallery(colour, selectImage) {
        this.hasChosen = this.hasChosen || selectImage;
        const gallery = this.root.querySelector('media-gallery');
        if (!gallery) return;
        const rawSlide = Array.from(gallery.querySelectorAll('.product__media-item[data-media-id]'))
          .find((slide) => /full poster artwork/i.test(slide.querySelector('img')?.alt || ''));
        if (rawSlide) {
          if (rawSlide.parentElement.firstElementChild !== rawSlide) rawSlide.parentElement.prepend(rawSlide);
          const rawThumbnail = Array.from(gallery.querySelectorAll('[data-target]'))
            .find((thumbnail) => thumbnail.dataset.target === rawSlide.dataset.mediaId);
          if (rawThumbnail && rawThumbnail.parentElement.firstElementChild !== rawThumbnail) {
            rawThumbnail.parentElement.prepend(rawThumbnail);
          }
        }
        const slides = Array.from(gallery.querySelectorAll('.product__media-item[data-media-id]'));
        const colourOf = (slide) => (slide.querySelector('img')?.alt.match(/#(Unframed|Black|White|Oak)\b/i)?.[1] || '').toLowerCase();
        const allowed = new Set();
        slides.forEach((slide) => {
          const frame = colourOf(slide);
          const isRaw = /full poster artwork/i.test(slide.querySelector('img')?.alt || '');
          slide.hidden = Boolean((frame && frame !== colour) || (isRaw && colour !== 'unframed' && this.hasChosen));
          if (!slide.hidden) {
            slide.classList.remove('scroll-trigger--offscreen');
            const image = slide.querySelector('img');
            if (image && this.sceneOf(slide) === 'wall hung') {
              image.loading = 'eager';
              image.fetchPriority = 'high';
            }
            allowed.add(slide.dataset.mediaId);
          }
        });
        let position = 0;
        gallery.querySelectorAll('[data-target]').forEach((thumbnail) => {
          const isRaw = /full poster artwork/i.test(thumbnail.querySelector('img')?.alt || '');
          thumbnail.hidden = (isRaw && colour !== 'unframed') || !allowed.has(thumbnail.dataset.target);
          if (!thumbnail.hidden) thumbnail.dataset.mediaPosition = String(++position);
        });
        const matching = slides.filter((slide) => colourOf(slide) === colour);
        const raw = slides.find((slide) => /full poster artwork/i.test(slide.querySelector('img')?.alt || ''));
        const active = slides.find((slide) => slide.classList.contains('is-active'));
        const target = selectImage
          ? (colour === 'unframed' && raw) || matching.find((slide) => this.scene && this.sceneOf(slide) === this.scene) || matching[0]
          : active && !active.hidden ? active : raw || matching[0];
        if (target) target.classList.remove('scroll-trigger--offscreen');
        gallery.querySelectorAll('slider-component').forEach((slider) => slider.resetPages?.());
        if (target && target !== active) gallery.setActiveMedia?.(target.dataset.mediaId, false);
        this.root.querySelectorAll('.product-media-modal__content [data-media-id]').forEach((item) => {
          const image = item.matches('img') ? item : item.querySelector('img');
          const frame = (image?.alt.match(/#(Unframed|Black|White|Oak)\b/i)?.[1] || '').toLowerCase();
          const isRaw = /full poster artwork/i.test(image?.alt || '');
          item.hidden = Boolean((frame && frame !== colour) || (isRaw && colour !== 'unframed' && this.hasChosen));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["deco-multibuy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('deco-multibuy')) {
    customElements.define('deco-multibuy', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        this.currency = this.dataset.currency || 'ZAR';
        this.controller = new AbortController();
        this.addEventListener('click', (event) => this.onClick(event), { signal: this.controller.signal });
        this.root?.addEventListener('change', (event) => {
          if (event.target.closest('variant-selects')) this.updateVariantPrice();
        }, { signal: this.controller.signal });
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, () => this.updateVariantPrice());
          this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart());
        }
        this.updateVariantPrice();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.unsubscribeVariant?.();
        this.unsubscribeCart?.();
      }

      money(cents) {
        const amount = Math.round(Number(cents || 0)) / 100;
        const hasCents = Math.round(Number(cents || 0)) % 100 !== 0;
        return new Intl.NumberFormat('en-ZA', {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: hasCents ? 2 : 0,
          maximumFractionDigits: hasCents ? 2 : 0
        }).format(amount).replace(/\u00a0/g, '');
      }

      selectedVariant() {
        const values = Array.from(this.root?.querySelectorAll('variant-selects input[type="radio"]:checked') || []).map((input) => input.value);
        let variants = [];
        try {
          variants = JSON.parse(this.root?.querySelector('[data-deco-variants]')?.textContent || '[]');
        } catch {
          variants = [];
        }
        return variants.find((variant) => variant.options.length === values.length && variant.options.every((value, index) => value === values[index]));
      }

      updateVariantPrice() {
        const variant = this.selectedVariant();
        if (variant?.price != null) {
          this.dataset.variantPrice = String(variant.price);
          this.dataset.pairDiscount = 'true';
        }
        this.render();
      }

      async refreshCart() {
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          this.dataset.cartCount = String(cart.item_count || 0);
          this.dataset.cartOriginal = String(cart.original_total_price || 0);
          this.dataset.cartTotal = String(cart.total_price || 0);
          if (cart.currency) this.currency = cart.currency;
          this.render();
        } catch {
          this.render();
        }
      }

      projectedRegular(milestone) {
        const count = Number(this.dataset.cartCount || 0);
        const cartOriginal = Number(this.dataset.cartOriginal || 0);
        const variantPrice = Number(this.dataset.variantPrice || 0);
        const needed = Math.max(0, milestone - count);
        return cartOriginal + (variantPrice * needed);
      }

      appliedPrice(milestone, regular) {
        const discountRate = milestone === 2 ? 0.95 : 0.85;
        return Math.round(regular * discountRate);
      }

      status(milestone, count) {
        if (count >= milestone) return this.dataset.textInCart;
        const missing = milestone - count;
        if (milestone === 1) return this.dataset.textChoose;
        if (count === 0) return milestone === 2 ? this.dataset.textBuildPair : this.dataset.textBuildSet;
        return missing === 1 ? this.dataset.textAddOne : this.dataset.textAddTwo;
      }

      render() {
        const count = Number(this.dataset.cartCount || 0);
        const variantPrice = Number(this.dataset.variantPrice || 0);
        const single = this.querySelector('[data-milestone="1"]');
        if (single) {
          const complete = count >= 1;
          single.classList.toggle('deco-multibuy__choice--complete', complete);
          single.classList.toggle('deco-multibuy__choice--active', count === 1);
          single.disabled = count >= 1;
          single.querySelector('[data-status]').textContent = this.status(1, count);
          single.querySelector('[data-single-price]').textContent = this.money(variantPrice);
          single.querySelector('[data-price]').hidden = complete;
        }
        [2, 3].forEach((milestone) => {
          const card = this.querySelector(`[data-milestone="${milestone}"]`);
          if (!card) return;
          const regular = this.projectedRegular(milestone);
          const discounted = this.appliedPrice(milestone, regular);
          const complete = count >= milestone;
          card.classList.toggle('deco-multibuy__choice--complete', complete);
          card.classList.toggle('deco-multibuy__choice--active', count === milestone || (milestone === 3 && count >= 3));
          card.disabled = complete;
          card.querySelector('[data-status]').textContent = this.status(milestone, count);
          const regularPrice = card.querySelector('[data-regular]');
          if (regularPrice) {
            regularPrice.textContent = this.money(regular);
            regularPrice.hidden = false;
          }
          card.querySelector('[data-discounted]').textContent = this.money(discounted);
          card.querySelector('[data-price]').hidden = complete;
        });
      }

      async onClick(event) {
        const disabled = event.target.closest('[aria-disabled="true"], button:disabled');
        if (disabled) {
          event.preventDefault();
          return;
        }
        if (event.target.closest('[data-add-current]')) {
          event.preventDefault();
          this.root?.querySelector('.product-form__submit:not([disabled])')?.click();
          return;
        }
        const builder = event.target.closest('[data-build-set]');
        if (builder) {
          event.preventDefault();
          const count = Number(this.dataset.cartCount || 0);
          if (count === 0) {
            const submit = this.root?.querySelector('.product-form__submit:not([disabled])');
            if (submit) {
              submit.click();
              await new Promise((resolve) => window.setTimeout(resolve, 700));
            }
          }
          window.location.assign(this.dataset.collectionUrl);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
